import { render, staticRenderFns } from "./ReadAdditionalCost.vue?vue&type=template&id=34d7b5ac&scoped=true"
import script from "./ReadAdditionalCost.vue?vue&type=script&lang=js"
export * from "./ReadAdditionalCost.vue?vue&type=script&lang=js"
import style0 from "./ReadAdditionalCost.vue?vue&type=style&index=0&id=34d7b5ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d7b5ac",
  null
  
)

export default component.exports